import cepPromise from "cep-promise";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import UploadButton from "../../../components/UploadButton/UploadButton";
import { useListManager } from "../../../contexts/list.manager";
import removeMask from "../../../functions/RemoveMask";
import ClientLicenceService from "../../../services/ClientLicenceService";
import ClientService from "../../../services/ClientService";
import ImagesService from "../../../services/ImagesService";
import "./FormClients.css";
import ResponsibleList from "../../../components/ResponsibleList/ResponsibleList";
import ResponsibleModal from "./ResponsibleModal";
import Button from "../../../components/Button/Button";
import { Buffer } from "buffer";
import { BsPeople } from "react-icons/bs";

function PartialFormClients(props) {
   const [nome, setNome] = useState(props.client?.name);
   const [cpfOrCnpj, setCpfOrCnpj] = useState(props.client?.document || "");
   const [bairro, setBairro] = useState(props.client?.address?.district);
   const [rua, setRua] = useState(props.client?.address?.streetName);
   const [numero, setNumero] = useState(props.client?.address?.streetNumber);
   const [complemento, setComplemento] = useState(props.client?.address?.complement);
   const [cidade, setCidade] = useState(props.client?.address?.city);
   const [uf, setUf] = useState(props.client?.address?.uf);
   const [pais, setPais] = useState(props.client?.address?.country);
   const [telefone, setTelefone] = useState(props.client?.phone);
   const [mail, setMail] = useState(props.client?.email);
   const [site, setSite] = useState(props.client?.site);
   const [responsibles, setResponsibles] = useState([]);
   const [showRespModal, setShowRespModal] = useState(false);
   const [tema, setTema] = useState(props.client?.theme);
   const [urlLogo, setUrlLogo] = useState(props.client?.urlLogo);
   const [showLoader, setShowLoader] = useState(false);
   const [photoFile, setPhotoFile] = useState();
   const [currentPhotoFile, setCurrentPhotoFile] = useState();

   const [cep, setCep] = useState(props.client?.cep);
   const [primaryColor, setPrimaryColor] = useState(props.client?.primaryColor || "");
   const [secondaryColor, setSecondaryColor] = useState(props.client?.secondaryColor || "");

   const { closeForm } = useListManager();

   async function loadCurrentPhotoFile() {
      const response = await ImagesService.getImage(props.client?.urlLogo);
      if (!response.data) return;
      const responseImage = await ImagesService.getRawImage(response.data.replace("[:STORAGE_ADDRESS:]", window.location.hostname));
      const binaryData = responseImage.data;
      const base64Data = new Buffer.from(binaryData, "binary").toString(
         "base64",
      );
      const originalDataUrl = `data:image/png;base64,${base64Data}`;
      setCurrentPhotoFile(originalDataUrl);
   }

   useEffect(() => {
      setNome(props.client?.name);
      setCpfOrCnpj(props.client?.document || "");
      setBairro(props.client?.address?.district);
      setRua(props.client?.address?.streetName);
      setNumero(props.client?.address?.streetNumber);
      setComplemento(props.client?.address?.complement);
      setCidade(props.client?.address?.city);
      setUf(props.client?.address?.state);
      setPais(props.client?.address?.country);
      setTelefone(props.client?.phone);
      setMail(props.client?.email);
      setSite(props.client?.site);
      setResponsibles(props.client?.responsibles || []);
      setTema(props.client?.theme);
      setUrlLogo(props.client?.urlLogo);
      setCep(props.client?.address?.postalCode);
      setPrimaryColor(props.client?.primaryColor);
      setSecondaryColor(props.client?.secondaryColor);
      if (props.client?.urlLogo) {
         loadCurrentPhotoFile();
      }
   }, [props.client]);

   const navigate = useNavigate();

   const buildPayload = (urlFromResponse) => {
      const processedResponsibles = responsibles.map(resp => {
         let newResp = { ...resp };
         // Check if email field contains '@', otherwise treat as phone
         if (newResp.email && !newResp.email.includes('@')) {
            newResp.phone = newResp.email;
            delete newResp.email;
         }
         return newResp;
      });

      let payload = {
         // name: nome,
         // document: removeMask(cpfOrCnpj),
         // phone: removeMask(telefone),
         // email: mail,
         site: site,
         defaultTheme: tema,
         urlLogo: urlFromResponse ?? urlLogo,
         primaryColor,
         secondaryColor,
         address: {
            id: props.client?.address?.id,
            district: bairro,
            streetName: rua,
            streetNumber: Number(numero),
            complement: complemento,
            city: cidade,
            state: uf,
            country: pais,
            postalCode: removeMask(cep),
         },
         responsibles: processedResponsibles,
      };
      return payload;
   };

   async function handlePhotoSubmission() {
      let newUrl = null;
      if (photoFile) {
         const formData = new FormData();
         formData.append("file", photoFile);
         formData.append("entity", "organization");
         formData.append("organizationExternalId", props.client?.externalId);
         const response = await ImagesService.storeImage(formData);
         return response.data.payload.id;
      }
      return newUrl;
   }

   async function handleSubmit(event) {
      event.preventDefault();
      setShowLoader(true);
      const urlFromResponse = await handlePhotoSubmission();
      const payload = buildPayload(urlFromResponse);
      let response = {};
      response = await ClientService.partialUpdateClient(props.client.id, payload);
      setShowLoader(false);
      if (!response.data.id) return;
      navigate("../consulta-clientes", { replace: true, state: {} });
   }

   async function handleDelete() {
      setShowLoader(true);
      if (!props.client) return;
      await ClientService.deleteClient(props.client.id);
      navigate("../consulta-clientes", {
         replace: true, state: {},
      });
      setShowLoader(false);
      closeForm();
   }

   const handleClickEditButton = () => {
      if (!props.client) return;
      navigate("/cadastro-clientes", { state: props.client });
   };

   const handleCepBlur = (cepValue) => {
      const digits = cepValue.replace(/\D/g, "");
      if (cepValue && digits.length === 8) {
         cepPromise(cepValue)
            .then((result) => {
               setBairro(result.neighborhood || "");
               setRua(result.street || "");
               setCidade(result.city || "");
               setUf(result.state || "");
               setPais("Brasil");
            })
            .catch((error) => {
               console.error("CEP inválido ou não encontrado:", error);
            });
      }
   };

   function handleAddResponsible(resp) {
      if (responsibles.find(responsible => responsible.externalId === resp.externalId || responsible.email === resp.email || responsible.phone === resp.phone)) {
         return;
      }
      setResponsibles([...responsibles, resp]);
   }

   function handleRemoveResponsible(index) {
      const newList = [...responsibles];
      newList.splice(index, 1);
      setResponsibles(newList);
   }

   return (
      <React.Fragment>
         {showLoader ? (
            <Loader />
         ) : (
            <Form
               handleSubmit={handleSubmit}
               type={props.type}
               handleClickEdit={handleClickEditButton}
               handleDelete={handleDelete}
               askForPasswordOnDelete={true}
               className="partial-organization-form"
               hideCancelButton={true}
            >
               <div className="container-image-info-name mb-2!">
                  <UploadButton
                     onFileChanged={(file) => setPhotoFile(file)}
                     label="Importar Logo"
                     disabled={props.type === "consulta"}
                     currentFileBase64={currentPhotoFile}
                  />
                  <div className="container-info-client">
                     <div className="container-name-cpf">
                        <div className="grid-2">
                           <Input
                              name={"nome"}
                              id="nome"
                              labelText={"Nome da Empresa *"}
                              value={nome}
                              onChange={({ target }) => setNome(target.value)}
                              disabled={true}
                           />
                           <Input
                              name="cpf_cnpj"
                              id="cpf_cnpj"
                              labelText="CPF/CNPJ *"
                              value={cpfOrCnpj}
                              onChange={({ target }) => setCpfOrCnpj(target.value)}
                              minLength={"14"}
                              maxLength={"18"}
                              showCpfCnpjMask={cpfOrCnpj.length >= 11}
                              showCpfMask={cpfOrCnpj.length <= 11}
                              disabled={true}
                           />
                        </div>
                        <div className="grid-3">
                           <Input
                              name={"telefone"}
                              id="telefone"
                              labelText={"Telefone *"}
                              value={telefone}
                              onChange={({ target }) => setTelefone(target.value)}
                              hidden={props.type === "consulta"}
                              showPhoneMask={true}
                              minLength={"15"}
                              maxLength={"15"}
                              disabled={true}
                           />
                           <Input
                              placeholder="exemplo@email.com"
                              name={"mail"}
                              id="mail"
                              labelText={"E-mail *"}
                              value={mail}
                              onChange={({ target }) => setMail(target.value)}
                              disabled={true}
                           />
                           <Input
                              name={"site"}
                              id="site"
                              labelText={"Site"}
                              onChange={({ target }) => setSite(target.value)}
                              value={site}
                              hidden={props.type === "consulta"}
                           />
                        </div>
                        <div className="grid-2">
                           <Input
                              name="primaryColor"
                              id="primaryColor"
                              type="color"
                              labelText="Cor primária"
                              value={primaryColor}
                              onChange={({ target }) => setPrimaryColor(target.value)}
                              disabled={props.formMode === "consulta"}
                              required={false}
                           />
                           <Input
                              name="secondaryColor"
                              id="secondaryColor"
                              type="color"
                              labelText="Cor secundária"
                              value={secondaryColor}
                              onChange={({ target }) => setSecondaryColor(target.value)}
                              disabled={props.formMode === "consulta"}
                              required={false}
                           />
                        </div>
                     </div>
                  </div>
               </div>
               <div className="responsibles-container" style={{ width: '100%', marginBottom: '15px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                     <h4 className="input-label" style={{ marginBottom: 0 }}>Responsáveis *</h4>
                     <div className="container-buttons" style={{ width: '100%', flexDirection: 'row', justifyContent: 'end', marginTop: 0 }}>
                        {props.type !== "consulta" && (
                           <Button
                              label="Adicionar"
                              action="add"
                              onClick={() => setShowRespModal(true)}
                              className="button-link"
                           />
                        )}
                     </div>
                  </div>
                  <ResponsibleList
                     responsibles={responsibles}
                     onRemove={handleRemoveResponsible}
                     disabled={props.type === "consulta"}
                  />
               </div>
               {/* Seção de Endereço */}
               <div className="address-section mt-0!">
                  <h3 className="muted-md mt-0!">Endereço</h3>
                  <Input
                     name="cep"
                     id="cep"
                     labelText="CEP *"
                     value={cep}
                     maxLength="9"
                     onChange={(e) => {
                        const val = e.target.value;
                        setCep(val);
                        if (val.replace(/\D/g, "").length === 8) {
                           handleCepBlur(val);
                        }
                     }}
                     required={true}
                     disabled={props.type === "consulta"}
                     mask="CEP"
                  />
                  <Input
                     name="rua"
                     id="rua"
                     labelText="Rua *"
                     value={rua}
                     onChange={({ target }) => setRua(target.value)}
                     required={true}
                     disabled={props.type === "consulta"}
                  />
                  <Input
                     name="bairro"
                     id="bairro"
                     labelText="Bairro *"
                     value={bairro}
                     onChange={({ target }) => setBairro(target.value)}
                     required={true}
                     disabled={props.type === "consulta"}
                  />
                  <Input
                     name="numero"
                     id="numero"
                     labelText="Número *"
                     value={numero}
                     onChange={({ target }) => setNumero(target.value)}
                     required={true}
                     disabled={props.type === "consulta"}
                  />
                  <Input
                     name="complemento"
                     id="complemento"
                     labelText="Complemento"
                     value={complemento}
                     onChange={({ target }) => setComplemento(target.value)}
                     disabled={props.type === "consulta"}
                  />
                  <Input
                     name="cidade"
                     id="cidade"
                     labelText="Cidade *"
                     value={cidade}
                     onChange={({ target }) => setCidade(target.value)}
                     required={true}
                     disabled={props.type === "consulta"}
                  />
                  <Input
                     name="uf"
                     id="uf"
                     labelText="UF *"
                     value={uf}
                     onChange={({ target }) => setUf(target.value)}
                     required={true}
                     disabled={props.type === "consulta"}
                  />
                  <Input
                     name="pais"
                     id="pais"
                     labelText="País *"
                     value={pais}
                     onChange={({ target }) => setPais(target.value)}
                     required={true}
                     disabled={props.type === "consulta"}
                  />
               </div>
            </Form>
         )
         }
         <ResponsibleModal
            isOpen={showRespModal}
            onClose={() => setShowRespModal(false)}
            onAdd={handleAddResponsible}
         />
      </React.Fragment >
   );
}

export default PartialFormClients;
